// @ts-expect-error untyped import
import events from '../../events.yaml';
export const EVENTS = Object.keys(events).reduce((map, event) => Object.assign({}, map, {
  [event]: event
}), {});